import React from 'react';
import Layout from '@components/global/main/layout';
import Footer from '@components/global/main/footer';
import Company from '@data/company.json';
import ScolarShip from '@data/academy.json';
import Navbar from '@components/global/main/navbar';

const ScolarShipEdu = () => {
  return (
    <Layout>
      <Navbar />
      <div className="bg-gradient-to-tr from-[] via-[] to-[] pt-24 md:pt-32 pb-10 px-4 md:px-8">
        <div className="max-w-7xl bg-white mx-auto grid lg:grid-cols-3 rounded-lg p-8 gap-10 items-center">
          <h1 className="font-bold text-xl text-black md:text-2xl lg:col-span-3 uppercase">
            <b className="text-mainc">Эдүлайн</b> нэрэмжит тэтгэлэг
          </h1>
          <div className="flex justify-center">
            <img
              src="/assets/home/scholarship1.png"
              alt=""
              className="object-cover rounded-lg w-full h-auto sm:h-96 sm:w-96 md:h-auto"
            />
          </div>
          <div className="grid md:grid-cols-2 gap-8 items-center lg:col-span-2">
            {ScolarShip?.scolar?.map((s, i) => (
              <div
                key={i}
                className={`flex gap-4  ${
                  i === 0 || i === 2 ? 'md:mt-24 lg:mt-40' : 'md:mt-8'
                } `}
              >
                <div>
                  <div
                    className={`h-8 w-8 md:h-10 md:w-10 bg-${s?.img} rounded-full`}
                  />
                </div>
                <div className="space-y-2">
                  <h1 className="font-semibold md:text-lg text-base">
                    {s?.title}
                  </h1>
                  <p className="text-justify text-sm md:text-base opacity-80">
                    {s?.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer companyInfo={Company} />
    </Layout>
  );
};

export default ScolarShipEdu;
